var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { FEEDBACK, STAFF, getAll, getEntities } from '../reducers/index';
import { createSelector } from 'reselect';
export var getFeedbackState = function (state) { return state.auth; };
export var feedbackWithMember = createSelector(getAll(FEEDBACK), getEntities(STAFF), function (feedback, staff) {
    return feedback.map(function (item) { return (__assign({}, item, { member: staff[item.memberId] })); });
});
